import { ThemeDefinition } from 'vuetify'

export const themes: Record<string, ThemeDefinition> = {
  dark: {
    dark: true,
    variables: {
      'custom-font-family': '"Roboto", sans-serif',
    },
    colors: {
      primary: '#3ea200',
      secondary: '#6786ff',
      accent: '#90ff8b',
      text: '#fff',
      border: '#fff',
      background: 'rgb(251,251,251)',
      surface: 'rgb(251,251,251)',
    }
  },
  dolomitenstadt: {
    dark: false,
    variables: {
      'custom-font-family': '"LinetoCircular", sans-serif',
    },
    colors: {
      primary: '#663399',
      secondary: '#ff0000',
      accent: '#60cc65',
      info: '#ed8c60',
      text: '#212529',
      background: 'rgb(251,251,251)',
      surface: 'rgb(251,251,251)',
      border: 'rgba(33, 37, 41, 0.5)'
    }
  },
  salto: {
    dark: false,
    variables: {
      'custom-font-family': '"SourceSansPro", sans-serif',
    },
    colors: {
      primary: '#0D6EFD',
      secondary: '#03a9ef',
      accent: '#8EE4AF',
      info: '#fbf489',
      text: '#212529',
      background: 'rgb(251,251,251)',
      surface: 'rgb(251,251,251)',
      border: 'rgba(33, 37, 41, 0.5)'
    }
  }
}